import { Fragment, useEffect, useReducer, useState } from "react";
import { Pagination } from "@sainsburys-tech/luna-pagination";
import {
  initialState,
  reducer,
} from "../../../../Redux/Reducers/paginationReducer";
import * as CONSTANTS from "../../../../Constants";
import {
  errorToast,
  successToast,
} from "../../../../Service-Utils/toastMessage";
import { getRequestApi, useGetApi } from "../../../../Redux/Hooks/useGetApi";
import { Container } from "@sainsburys-tech/luna-grid";
import CustomToast from "../../../SharedComponents/CustomToast";
import LoadingIndicator from "../../../Loading/index";
import { IRequestParams } from "../../../../Interfaces/IRequestParams";
import EditableGridLuna from "../../../SharedComponents/EditableTable";
import { usePostApiRequestAxios } from "../../../../Redux/Hooks/usePostApi";
import { FilterTypeForProduct } from "../../../../Types/filterTypeForProduct";
import { useSelector } from "react-redux";
import { filterPayloadType } from "../../../../Types/filterPayloadType";
import { storeFilter } from "../../../../Redux/Actions/filterActions";
import store from "../../../../Store/store";
import { decoratePayloadAndEndPoint } from "./decoratePayloadAndEndPointHelper";
import { storeSearchCount } from "../../../../Redux/Actions/searchCountAction";
import { emptyEditTablePayload } from "../../../../Redux/Actions/editTableActions";
import { storeSaveResponse } from "../../../../Redux/Actions/popupActions";
import { consolelog } from "../../../../helpers/consolelog";
import { IsNullEmptyOrUndefined } from "../../../../helpers/StringHelpersMethods";
import { updateDataListOrdered } from "./dataTableHelper";
import { getDataFromApiResponse } from "./apiDataHelper";
import { formatFilterQueryString, methodForGetApi, serviceForGetApi } from "./apiQueryHelper";
import { AxiosResponse, AxiosError } from "axios";
import { extractErrorMessage } from "../../../../helpers/messageHelper";
import { endpoints } from "../../../../ApiEndPoints/apiEndPoints";

const DataTable = (props: FilterTypeForProduct) => {
  const [isError, setIsError] = useState(false);
  const [productData, setProductData] = useState<Array<any> | null>(null);
  const [query, setQuery] = useState<string>("");
  const [postUpdateRefetching, setPostUpdateRefetching] = useState(false);
  const [lastUpdatedProductId, setLastUpdatedProductId] = useState<string | null>(null);
  const [isDataQueryEnabled, setIsDataQueryEnabled] = useState<boolean>(true);

  const paramsPorPost = {
    onSuccess(result: any) {
      onSuccess(result);
    },
    onError(error: AxiosError) {
      onErrorPost(error);
    },
  };

  const {
    data: filter,
    isDirectQuery,
    parentName,
    selectedMenu,
    searchPageReset,
    nestedSearchId,
    codeScreen,
    isSearchBoxTrigger,
  }: filterPayloadType = useSelector((state: any) => state.filterReducer.data);

  const dataTableReducerState = useSelector((state: any) => state.dataTableReducer);
  let menuHeaderPayload = useSelector((state: any) => state.menuHeaderReducer);

  const {
    mutate,
    isLoading: updateLoading,
    isSuccess: isMutateSuccess,
  } = usePostApiRequestAxios(paramsPorPost);

  const [{ queryPageIndex, skip, queryPageSize, totalCount, navigation: { from, to }, pageNavigationDirection }, dispatch] =
    useReducer(reducer, initialState);

  const onSave = (editableData: any) => {
    const { payload, headers, endPoint, method } = decoratePayloadAndEndPoint(
      editableData,
      isDirectQuery
        ? selectedMenu
        : IsNullEmptyOrUndefined(menuHeaderPayload?.data?.selectedMenu)
          ? selectedMenu
          : menuHeaderPayload?.data?.selectedMenu
    );
    props.toggleSearchPanel(false);
    const params = {
      service: endPoint,
      method: method,
      payload: payload,
      headers: headers,
    };

    mutate(params);
    store.dispatch(emptyEditTablePayload());
    setLastUpdatedProductId(editableData?.Id);
  };

  useEffect(() => {
    setIsDataQueryEnabled(true);
  }, [queryPageIndex, query]);

  const refreshProductDataWithLatestUpdate = async (productId: string, selectedMenu: string | undefined) => {
    setPostUpdateRefetching(true);

    const updatedProductResponse: AxiosResponse<any> = await getRequestApi<AxiosResponse<any>>({
      service: selectedMenu === "Food Volumetrics"
        ? endpoints.getVolumetricsReviewDataById(productId)
        : endpoints.getProductById(productId),      
      take: 1
    });

    if (updatedProductResponse) {
      const updatedProduct = selectedMenu === "Food Volumetrics"
        ? updatedProductResponse?.data?.value[0]
        : updatedProductResponse?.data;
      const updatedProductsList = updateDataListOrdered<any>(updatedProduct, productData || []);
      setProductData(() => updatedProductsList);
    }

    setPostUpdateRefetching(false);
    setLastUpdatedProductId("");
  };

  useEffect(() => {
    if (isMutateSuccess && lastUpdatedProductId) {
      refreshProductDataWithLatestUpdate(lastUpdatedProductId, selectedMenu);
    }
  }, [isMutateSuccess, lastUpdatedProductId]);

  const onSuccess = (data: any) => {
    if (data.isAxiosError) {
      let msg = `${data.response.status} ${data.message} ${data.statusText}`;
      setIsError(true);
      errorToast(data.message);
      store.dispatch(storeSaveResponse({ status: "error", message: data.message }));
      consolelog(msg);
    } else if (data.status === 201 || data.status === 204) {
      successToast("Data Updated Successfully, Refetching Data...");
      setIsError(false);
      store.dispatch(storeSaveResponse({ status: "success" }));
    } else if (data.status !== 200) {
      errorMsg(data.message);
      store.dispatch(storeSaveResponse({ status: "error", message: data.message }));
    } else if (data.status === 200) {
      store.dispatch(storeSearchCount(data.data["@odata.count"]));
      setProductData(getDataFromApiResponse(data, props));
      setIsDataQueryEnabled(false);
    }
  };

  const onErrorPost = (axiosError: AxiosError) => {
    let error: string | string[] = extractErrorMessage(axiosError);
    let errorMessages: string[] = Array.isArray(error) ? error : error.split(/[\r\n.;]+/).filter(msg => msg.trim() !== "");

    setIsDataQueryEnabled(false);
    errorToast(<ul style={{ height: "fit-content", margin: 10 }}>
      {errorMessages.map((msg, index) => <Fragment key={`${msg}-${index}`}><li>{msg}</li><br /></Fragment>)}
    </ul>, 8000);
    store.dispatch(storeSaveResponse({ status: "error", message: "Validation error" }));
  };

  const onErrorGet = (error: AxiosError) => {
    setIsError(true);
    setIsDataQueryEnabled(false);
    errorToast(extractErrorMessage(error));
  };

  useEffect(() => {
    if (
      menuHeaderPayload !== null &&
      menuHeaderPayload.data !== null &&
      props.service.indexOf("Dimension") > 0
    ) {
      if (menuHeaderPayload.data.selectedMenu === "Measurements") {
        let queryData = `${dataTableReducerState.data.filter} and (${menuHeaderPayload?.data?.data}) &${dataTableReducerState.data.orderBy}`;
        menuHeaderPayload = null;
        return setQuery(queryData);
      }
    }

    if (dataTableReducerState.data.filter === undefined && filter === "") {
      return setQuery("");
    } else if (dataTableReducerState.data.filter !== undefined && filter === "") {
      return setQuery(`${dataTableReducerState.data.filter} & ${dataTableReducerState.data.orderBy}`);
    } else if (dataTableReducerState.data.filter === undefined && filter !== "") {
      return setQuery(filter);
    } else if (dataTableReducerState.data.filter !== undefined && filter !== "") {
      return setQuery(
        `${dataTableReducerState.data.filter} and (${filter})&${dataTableReducerState.data.orderBy}`
      );
    } else {
      return setQuery("");
    }
  }, [dataTableReducerState.data.filter, filter, dataTableReducerState.data.orderBy]);

  useEffect(() => {
    dispatch({
      type: CONSTANTS.SEARCH_PAGE_RESET,
      payload: 0
    });
    setIsDataQueryEnabled(true);
  }, [props.service]);

  const getPaginationToken = (): string | null => {
    if (Math.abs(from - to) > 1) {
      return "";
    }

    if (!productData || productData.length === 0) {
      return null;
    }

    return (from < to)
        ? productData.at(-1)?.PaginationToken
        : productData.at(0)?.PaginationToken;
  };

  const params: IRequestParams = {
    service: props.service,
    skip: isSearchBoxTrigger ? 0 : skip,
    take: queryPageSize,
    isEnabled: isDataQueryEnabled,
    filter: formatFilterQueryString(query, parentName, selectedMenu, props.service),
    key: ``,
    isPaginationRequired: true,
    refetchOnWindowFocus: false,
    fromPage: from,
    toPage: to,
    pageNavigationDirection: pageNavigationDirection,
    paginationToken: getPaginationToken(),
    onError(error: any) {
      onErrorGet(error);
    },
    onSuccess(result: any) {
      onSuccess(result);
    },
  };

  const {
    data: apiResponse,
    isLoading,
    isRefetching,
    isSuccess,
  } = useGetApi({
    ...params,
    service: serviceForGetApi(params, { codeScreen, isDirectQuery, nestedSearchId }),
    method: methodForGetApi(params, { codeScreen, isDirectQuery, nestedSearchId })
  });

  useEffect(() => {
    if (
      searchPageReset === "searchQueryPageReset" ||
      searchPageReset === "fullPageReset"
    ) {
      if (
        apiResponse?.data !== undefined &&
        apiResponse?.data !== null &&
        apiResponse?.data["@odata.count"] > 0
      ) {
        dispatch({
          type: CONSTANTS.SEARCH_PAGE_RESET,
          payload: apiResponse?.data["@odata.count"],
        });
        let filterPayload: filterPayloadType = {
          data: searchPageReset === "fullPageReset" ? "" : filter,
          isDirectQuery: true,
          codeScreen: "DataTable 181",
          selectedMenu: selectedMenu,
          parentName: parentName,
          searchPageReset: "",
          nestedSearchId: nestedSearchId,
          createPopupName: undefined,
          deletePopupName: undefined,
          description: undefined,
          previousParentName: undefined,
          previousQueryData: undefined,
          searchId: undefined,
        };
        store.dispatch(storeFilter(filterPayload));
      }
    } else if (
      apiResponse?.data !== undefined &&
      apiResponse?.data !== null &&
      apiResponse?.data["@odata.count"] > 0 &&
      apiResponse?.data["@odata.count"] !== totalCount
    ) {
      dispatch({
        type: CONSTANTS.TOTAL_COUNT_CHANGED,
        payload: apiResponse?.data["@odata.count"],
      });
    }
  }, [apiResponse?.data, apiResponse?.data?.["@odata.count"]]);

  const errorMsg = (msg?: any) => {
    if (!isLoading) {
      consolelog("Error:", msg);
      return <div style={{ color: "red" }}>{msg}</div>;
    }
  };

  const shouldDisplayDataTable = () => {
    if (isDirectQuery) {
      return true;
    }

    if (parentName === "/familyGroupAdmin") {
      if (!(menuHeaderPayload?.data)) {
        return true;
      }

      if (menuHeaderPayload.data.parentName === "/product" && menuHeaderPayload.data.selectedMenu === "Food Volumetrics") {
        return false;
      }
    }

    return true;
  };

  return (
    <>
      {isLoading || !shouldDisplayDataTable() ? (
        errorMsg()
      ) : (
        <>
          <EditableGridLuna
            data={productData}
            columnDeffs={props.columnDefinition}
            rowKey="SainId,SkuNumber,CatNumber,PackSize"
            tableName="Product"
            onSave={onSave}
            isSortable={false}
          />
          {(productData && productData.length > 0) ? (
            <>
              <hr />
              <Container>
                <div style={{ float: "right" }}>
                  <Pagination
                    showFirstAndLast
                    current={queryPageIndex}
                    total={Math.ceil(totalCount / queryPageSize)}
                    onChange={(page: any, e: any) => {
                      e.preventDefault();
                      dispatch({ type: CONSTANTS.PAGE_CHANGED, payload: page });
                    }}
                    createHref={(page: any) => `/${page}`}
                  />
                </div>
              </Container>
              <hr />
              <Container className="marginTop4"> </Container>
              <hr />
            </>
          ) : (
            <>{!isError && errorMsg(CONSTANTS.ERROR_MESSAGES.noRecordsFound)}</>
          )}
        </>
      )}

      {(isLoading ||
        isRefetching ||
        updateLoading ||
        postUpdateRefetching) && <LoadingIndicator props={true} />}
      <CustomToast />
    </>
  );
};

export default DataTable;
